import { Box } from "@mui/material";

const StatusDot = ({ online }) => {
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: online ? "#D9EFFF" : "#707070", // bright green or red
        boxShadow: online
          ? `0 0 6px 2px rgba(180, 180, 180, 0.6)` // green glow
          : `0 0 6px 2px rgba(90, 90, 90, 0.0)`, // red glow
        ml: 1, // space from text
        mb: "-10px",
      }}
    />
  );
};

export default StatusDot;
